import { render, staticRenderFns } from "./SalesProductDetails.vue?vue&type=template&id=5e88dfce&scoped=true"
import script from "./SalesProductDetails.vue?vue&type=script&lang=js"
export * from "./SalesProductDetails.vue?vue&type=script&lang=js"
import style0 from "./SalesProductDetails.vue?vue&type=style&index=0&id=5e88dfce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e88dfce",
  null
  
)

export default component.exports